 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		115: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"0":"commons-0b7c41be","1":"commons-253ae210","2":"commons-2aef5174","3":"commons-31ecd969","4":"commons-45c7c1ae","5":"commons-92a4fe01","6":"commons-9b28023d","7":"commons-9c5b28f6","8":"../moment-lib-87d47d0c","9":"shared-6sI+DPbHATTXcp9U1qboQTGopM=-31ecd969","10":"shared-q0rxqSOt1RTgFbif8Z98m5qK2O8=-253ae210","11":"russian-31ecd969","12":"afaanoromoo-31ecd969","13":"afrique-31ecd969","14":"amharic-31ecd969","15":"arabic-31ecd969","16":"archive-31ecd969","17":"azeri-31ecd969","18":"bengali-31ecd969","19":"burmese-31ecd969","20":"cymrufyw-31ecd969","21":"gahuza-31ecd969","22":"gujarati-31ecd969","23":"hausa-31ecd969","24":"hindi-31ecd969","25":"igbo-31ecd969","26":"indonesia-31ecd969","27":"japanese-31ecd969","28":"korean-31ecd969","29":"kyrgyz-31ecd969","30":"marathi-31ecd969","31":"mundo-31ecd969","32":"naidheachdan-31ecd969","33":"nepali-31ecd969","34":"news-31ecd969","35":"newsround-31ecd969","36":"pashto-31ecd969","37":"persian-31ecd969","38":"pidgin-31ecd969","39":"portuguese-31ecd969","40":"punjabi-31ecd969","41":"scotland-31ecd969","42":"serbian-31ecd969","43":"sinhala-31ecd969","44":"somali-31ecd969","45":"sport-31ecd969","46":"swahili-31ecd969","47":"tamil-31ecd969","48":"telugu-31ecd969","49":"thai-31ecd969","50":"tigrinya-31ecd969","51":"turkce-31ecd969","52":"ukchina-31ecd969","53":"ukrainian-31ecd969","54":"urdu-31ecd969","55":"uzbek-31ecd969","56":"vietnamese-31ecd969","57":"yoruba-31ecd969","58":"zhongwen-31ecd969","59":"./StoryPage-lib-14f7988c","60":"ArticlePage-253ae210","61":"ArticlePage-88a3c260","62":"ErrorPage-c87660df","63":"FeatureIdxPage-253ae210","64":"FeatureIdxPage-88a3c260","65":"FeatureIdxPage-fd731fb0","66":"FrontPage-253ae210","67":"FrontPage-45c7c1ae","68":"FrontPage-747c59ed","69":"FrontPage-92a4fe01","70":"FrontPage-bc281d26","71":"FrontPage-d88b56c2","72":"FrontPage-dbb5839c","73":"FrontPage-fd731fb0","74":"IdxPage-253ae210","75":"IdxPage-31ecd969","76":"IdxPage-45c7c1ae","77":"IdxPage-88a3c260","78":"IdxPage-bc281d26","79":"IdxPage-dbb5839c","80":"LiveRadioPage-253ae210","81":"LiveRadioPage-45c7c1ae","82":"LiveRadioPage-88a3c260","83":"LiveRadioPage-cce0dd10","84":"MediaAssetPage-1481cd46","85":"MediaAssetPage-253ae210","86":"MediaAssetPage-88a3c260","87":"MediaAssetPage-bc437dc0","88":"MediaAssetPage-d008f717","89":"MostReadPage-31ecd969","90":"MostWatchedPage-253ae210","91":"MostWatchedPage-88a3c260","92":"OnDemandAudioPage-382adb6c","93":"OnDemandAudioPage-45c7c1ae","94":"OnDemandAudioPage-88a3c260","95":"OnDemandAudioPage-cce0dd10","96":"OnDemandAudioPage-d939e436","97":"OnDemandTvPage-253ae210","98":"OnDemandTvPage-88a3c260","99":"PhotoGalleryPage-1481cd46","100":"PhotoGalleryPage-253ae210","101":"PhotoGalleryPage-475e7ff2","102":"PhotoGalleryPage-88a3c260","103":"PhotoGalleryPage-d008f717","104":"StoryPage-04a78c7b","105":"StoryPage-0b7c41be","106":"StoryPage-1481cd46","107":"StoryPage-253ae210","108":"StoryPage-695b57f8","109":"StoryPage-88a3c260","110":"StoryPage-a39a3dd4","111":"StoryPage-cce0dd10","112":"StoryPage-d88b56c2","118":"rich-text-transforms-748942c6"}[chunkId]||chunkId) + "." + {"0":"a66c27dd","1":"adf81fe5","2":"91a5d5ce","3":"6a3c9164","4":"d199e67c","5":"2922876f","6":"13261d66","7":"8d950c91","8":"65097180","9":"fc4de4a8","10":"dcb40294","11":"fbba5e3a","12":"c67ed2f7","13":"66450739","14":"3e6779ef","15":"a4d9722d","16":"9ac2b241","17":"912a6b16","18":"cea1ffd5","19":"ca9cd12b","20":"f1e57a7f","21":"5d5ac040","22":"410a8561","23":"16a88279","24":"160d263f","25":"3f7c9da4","26":"aa18d10f","27":"6868b5ed","28":"eaddfc4b","29":"8f58c370","30":"d6477a1f","31":"50568158","32":"acc7636f","33":"056f8353","34":"480c0b94","35":"8888a1e3","36":"6bef895b","37":"6e0ed716","38":"f6b1e2c6","39":"497b6ad2","40":"6214edc0","41":"3de093d6","42":"1a3010d5","43":"f2022e92","44":"bd3e7e50","45":"7d32e56e","46":"1802e7a6","47":"2cf49401","48":"d2b3fea3","49":"f1c10871","50":"2591c9b0","51":"b0c9ff18","52":"2fe8f717","53":"94169f54","54":"7b8eb91a","55":"15e7658e","56":"d80fdc75","57":"f4725318","58":"ee0e34d9","59":"06a201e8","60":"833c843e","61":"51c23a1b","62":"b58c7142","63":"58be1379","64":"5927d866","65":"ea9a0ffd","66":"c10cae21","67":"63b95d67","68":"d873a75b","69":"420a1961","70":"74f289de","71":"cf4f814e","72":"e0a841bc","73":"680912a9","74":"44a83c45","75":"a341706c","76":"a0fea584","77":"917951a7","78":"b0198d6d","79":"99d7ef2d","80":"b62695be","81":"f89f9f91","82":"084a7298","83":"cf5435ea","84":"1953d0b3","85":"761c5425","86":"8643c61b","87":"4fcc41ab","88":"dba7df8c","89":"856e166b","90":"54c73d37","91":"6dedcd46","92":"102b7f20","93":"e49f6c09","94":"12792921","95":"82a5703f","96":"861e3f20","97":"4f3751e4","98":"6a5ba6c5","99":"af139832","100":"31d38b8c","101":"c7b0dd5c","102":"86be6114","103":"9412ee29","104":"a51965a7","105":"8f7e5049","106":"b532508d","107":"dc8e73b7","108":"6e7a5850","109":"a55ef225","110":"a6428d66","111":"d965b2e9","112":"2173702b","118":"a109c58b"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://static.files.bbci.co.uk/ws/simorgh-assets/public/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,113,116,114,117]);
 	// run deferred modules when ready
 	return checkDeferredModules();
